module.exports = __webpack_public_path__ + "img/reward-ico.654818a7.png";